// :cow: Cosmose CONFIDENTIAL :iso:
import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { loggedOut } from '@coa/app/auth/store/auth.actions';
import { selectDecodedToken } from '@coa/app/auth/store/auth.selectors';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'coa-home-header',
  templateUrl: './home-header.component.html',
  styleUrls: ['./home-header.component.scss'],
})
export class HomeHeaderComponent implements OnInit, OnDestroy {
  token$ = this.store$.pipe(select(selectDecodedToken));
  clientId = '';
  subscription: Subscription;
  @Output() toggleSidenav = new EventEmitter();

  constructor(private store$: Store,
              private activatedRoute: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.subscription = this.activatedRoute.params
      .subscribe((params) => {
        this.clientId = params.clientId;
      });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  logout() {
    this.store$.dispatch(loggedOut());
  }

  path() {
    return this.clientId ? ['/clients', this.clientId, 'dashboard'] : ['/select-client'];
  }
}
